import { render } from "./AboutMe.vue?vue&type=template&id=2c41b05a&scoped=true"
const script = {}

import "./AboutMe.vue?vue&type=style&index=0&id=2c41b05a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c41b05a"]])

export default __exports__